import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetsUrlPipe } from '../../../pipes/assets-url.pipe';
import { ModalComponent } from '../../shared/modal/modal.component';
import { UpaAsyncService } from '../../../services/upa-async.service';
import { redirectToUrl } from '../utils/navigation.utils';
import { LOGIN_URL, IFOOD_URL } from '../utils/urls.constants';

@Component({
  selector: 'al-your-points',
  standalone: true,
  templateUrl: './your-points.component.html',
  styleUrls: ['./your-points.component.scss'],
  imports: [CommonModule, AssetsUrlPipe, ModalComponent]
})
export class YourPointsComponent {
  @Input() isEnrolled: boolean | null = null;
  @Input() isClientNotEnrolled: boolean | null = null;
  @Input() isLoggedIn: boolean | null = null;
  @Input() points: number | null = null;
  @Input() showClubeEnrolledCashback = false;
  @Input() showNoClubeEnrolledCashback = false;
  @Input() showClubeNotEnrolledNotClientCashback = false;
  @Input() showNoClubeNotEnrolledNotClientCashback = false;
  @Input() source = '';

  private touchStartY: number | null = null;
  private touchEndY: number | null = null;

  showCashbackInfoModal = false;

  private upaAsyncService = inject(UpaAsyncService);


  get formattedPoints(): string {
    return this.points !== null && this.points !== undefined
      ? this.points.toLocaleString('de-DE')
      : '';
  }

  openCashbackInfoModal() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'como_funciona_a_parceria',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    this.showCashbackInfoModal = true;
  }

  closeCashbackInfoModal() {
    this.showCashbackInfoModal = false;
  }

  modalTouchStart(event: TouchEvent) {
    this.touchStartY = event.touches[0].clientY;
  }

  modalTouchMove(event: TouchEvent) {
    this.touchEndY = event.touches[0].clientY;
  }

  modalTouchEnd() {
    if (
      this.touchStartY !== null &&
      this.touchEndY !== null &&
      this.touchEndY - this.touchStartY > 60
    ) {
      this.closeCashbackInfoModal();
    }
    this.touchStartY = null;
    this.touchEndY = null;
  }

  onParceriaConnectIfoodClick() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        `parceria_conectar`,
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();

    redirectToUrl(IFOOD_URL);

    this.closeCashbackInfoModal();
  }

  onParceriaEntendiClick() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        `parceria_entendi`,
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();

    this.closeCashbackInfoModal();
  }

  onLoginClick() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'fazer_login',
        'click',
        'ifood-landing', {
        source: this.source,
      })
      .subscribe();
    redirectToUrl(LOGIN_URL);
  }

}
